import script from "./monthly-collections-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./monthly-collections-report-table.vue?vue&type=script&setup=true&lang=js"

import "./monthly-collections-report-table.vue?vue&type=style&index=0&id=ba925256&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba925256"]])

export default __exports__